import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/axiosInstance";

const TestimonialAdmin = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const loadTestimonials = async () => {
    const res = await api.get("/api/testimonials");
    setData(res.data);
  };

  const deleteItem = async (id) => {
    if (!window.confirm("Delete testimonial?")) return;
    await api.delete(`/api/testimonials/${id}`);
    loadTestimonials();
  };

  useEffect(() => {
    loadTestimonials();
  }, []);

  return (
    <div>
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">Testimonials</h1>
        <button
          onClick={() => navigate("/admin/testimonials/new")}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          + New
        </button>
      </div>

      <div className="bg-white border rounded">
        {data.map((t) => (
          <div
            key={t._id}
            className="flex justify-between items-center p-4 border-b"
          >
            <div>
              <p className="font-semibold">{t.name}</p>
              <p className="text-sm text-gray-500">{t.role}</p>
              <p className="text-xs text-gray-400">⭐ {t.rating}</p>
            </div>

            <div className="flex gap-4">
              <button
                onClick={() =>
                  navigate(`/admin/testimonials/edit/${t._id}`)
                }
                className="text-blue-600"
              >
                Edit
              </button>
              <button
                onClick={() => deleteItem(t._id)}
                className="text-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialAdmin;
